import '@fortawesome/fontawesome-free/css/all.min.css'
import '@factry/bulma'
import { initialize } from '@factry/base'
import App from './App.svelte'
import background from './assets/rogerroger-bg.jpg'
import logo from './assets/rogerroger-logo.svg'

initialize({
  background,
  defaultLocale: 'nl',
  availableLocales: ['nl', 'en', 'pl', 'fr'],
  basePath: import.meta.env.VITE_BASE_PATH,
  logo,
  logoAlt: 'Roger & Roger logo',
  test: import.meta.env.VITE_TEST,
  versions: import.meta.env.VITE_VERSIONS,
  organization: 'rogerandroger',
})

const app = new App({
  target: document.body,
})

export default app
